import { Loader } from "@/components/loader";
import SearchInput from "@/components/project/searchInput";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getActiveAreaId, getDrugListInArea } from "../../../../api/area";
import CustomTable from "../../../customTable/CustomTable";
import ReturnAllDrugsPop from "./returnAllDrugsPop";

export default function DrugTableInArea() {
  const [rowData, setRowData] = useState();
  const [pageable, setPageable] = useState({
    pageSize: 10,
    pageIndex: 0,
  });
  const [totalSizeOfDrugs, setTotalSizeOfDrugs] = useState();
  const md = useMediaQuery("(max-width:450px)");

  const [valueSearch, setValueSearch] = useState("");
  const [validValueSearch, setValidValueSearch] = useState();
  const [openReturnPop, setOpenReturnPop] = useState();
  const [loading, setLoading] = useState(false);
  const [areaId, setAreaId] = useState();

  useEffect(() => {
    getActiveAreaId().then((res) => {
      setAreaId(res);
    });
  }, []);

  const fetchData = useCallback(() => {
    setLoading(true);
    const params = new URLSearchParams();
    params.append("pageIndex", pageable.pageIndex);
    params.append("pageSize", pageable.pageSize);
    if (validValueSearch && validValueSearch.length > 2) {
      params.append("key", validValueSearch);
    }
    if (totalSizeOfDrugs === undefined) params.append("needTotalSize", true);
    getDrugListInArea(areaId, params)
      .then((x) => {
        setRowData(x.content);
        if (totalSizeOfDrugs === undefined)
          setTotalSizeOfDrugs(x.totalElements);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [areaId, pageable, validValueSearch]);

  useEffect(() => {
    if (areaId) fetchData();
  }, [areaId, pageable]);

  const colDefs = useMemo(
    () => [
      {
        headerName: "ردیف",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 100,
      },
      {
        field: "drugInfo.drugType",
        headerName: "نوع دارو",
        width: 140,
      },
      {
        field: "drugInfo.name",
        headerName: "اسم دارو",
        width: 350,
      },
      {
        headerName: "دوز دارو",
        width: 140,
        cellRenderer: (x) => {
          return (
            <Box key={`dose_${x.id}`} display="flex" alignItems="center">
              <Typography fontFamily="Vazirmatn">
                {x.data?.drugInfo?.dose}
              </Typography>
            </Box>
          );
        },
      },
      {
        headerName: "تاریخ انقضا",
        width: 140,
        cellRenderer: (x) => {
          return (
            <Box key={`expireAt_${x.id}`} display="flex" alignItems="center">
              <Typography fontFamily="Vazirmatn">
                {x.data?.drugInfo?.expireAt?.split("T", 2)[0]}
              </Typography>
            </Box>
          );
        },
      },
      {
        headerName: "شرکت سازنده",
        width: 140,
        cellRenderer: (x, options = {}) => {
          const isMobile = options.mobile ?? false;
          return (
            <Box
              key={`producer_${x.id}`}
              display="flex"
              alignItems="center"
              justifyContent={isMobile ? "end" : ""}
            >
              <Typography fontFamily="Vazirmatn">
                {x.data?.drugInfo?.producer}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: "reminder",
        headerName: "تعداد",
        width: 100,
      },
    ],
    [],
  );

  const [timer, setTimer] = useState();

  useEffect(() => {
    if (timer !== undefined) {
      clearTimeout(timer);
    }

    if (
      valueSearch.length >= 3 ||
      (valueSearch.length === 0 && validValueSearch !== undefined)
    ) {
      const timer = setTimeout(() => {
        setValidValueSearch(valueSearch.length >= 3 ? valueSearch : undefined);
        setPageable({
          pageIndex: 0,
          pageSize: pageable.pageSize,
        });
        setTotalSizeOfDrugs(undefined);
      }, 500);

      setTimer(timer);
    }

    return () => {
      if (timer !== undefined) {
        clearTimeout(timer);
      }
    };
  }, [valueSearch]);

  return (
    <>
      {loading && <Loader />}
      <Grid
        display={"flex"}
        flexDirection={md ? "column-reverse" : "row"}
        justifyContent={md ? "unset" : "space-between"}
        alignItems={"center"}
        gap={md ? "10px" : "unset"}
        mb={"10px"}
      >
        <Grid display={"flex"} flexDirection={"row"} sx={{ width: "100%" }}>
          <SearchInput
            type="text"
            id="filter-text-box-before-train"
            value={valueSearch}
            onChange={(e) => setValueSearch(e.target.value)}
          />
          {valueSearch.length >= 2 && (
            <Button
              onClick={() => {
                setValueSearch("");
                setValidValueSearch(undefined);
                setTotalSizeOfDrugs(undefined);
                setPageable({
                  pageIndex: 0,
                  pageSize: pageable.pageSize,
                });
              }}
            >
              پاک کردن فیلتر
            </Button>
          )}
        </Grid>
        <Grid
          display={"flex"}
          flexDirection={"row"}
          gap={"10px"}
          alignContent={"center"}
          alignItems={"center"}
          sx={md ? { width: "100%" } : { width: "unset" }}
        >
          {areaId && (
            <ReturnAllDrugsPop
              areaId={areaId}
              open={openReturnPop}
              setOpen={setOpenReturnPop}
              equipment={false}
            />
          )}

          <Button
            variant="outlined"
            color="error"
            sx={{ width: md ? "100%" : "max-content" }}
            onClick={() => setOpenReturnPop(!openReturnPop)}
          >
            بازگشت به داروخانه
          </Button>
        </Grid>
      </Grid>

      <CustomTable
        totalElements={totalSizeOfDrugs}
        onPageChange={(pageIndex, pageSize) => {
          setPageable({
            pageIndex: pageIndex,
            pageSize: pageSize,
          });
        }}
        pageSize={pageable.pageSize}
        currentPage={pageable.pageIndex}
        columns={colDefs}
        rowData={rowData}
      />
    </>
  );
}
